import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Common
      "language": "Language",
      "logout": "Logout",
      "cancel": "Cancel",
      "confirm": "Confirm",
      "submit": "Submit",
      "save": "Save",
      "edit": "Edit",
      "delete": "Delete",
      "search": "Search",
      "filter": "Filter",
      "back": "Back",
      
      // Landing Page
      "appName": "Saeed Taxi",
      "tagline": "Your Ride, Your Way",
      "description": "Book rides instantly across Syria with Saeed Taxi. Safe, reliable, and affordable transportation at your fingertips.",
      "bookRide": "Book a Ride",
      "becomeDriver": "Become a Driver",
      "adminPanel": "Admin Panel",
      
      // Passenger
      "whereAreYouGoing": "Where are you going?",
      "pickup": "Pickup Location",
      "dropoff": "Dropoff Location",
      "findRide": "Find a Ride",
      "selectCar": "Select a Car",
      "confirmRide": "Confirm Ride",
      "rideHistory": "Ride History",
      "myProfile": "My Profile",
      "economy": "Economy",
      "comfort": "Comfort",
      "premium": "Premium",
      "waitingForDriver": "Finding your driver...",
      "driverArriving": "Driver is arriving",
      "inProgress": "Ride in progress",
      "completed": "Ride completed",
      "rateDriver": "Rate your driver",
      "rateRide": "Rate Ride",
      "addTip": "Add Tip",
      "paymentMethod": "Payment Method",
      "cash": "Cash",
      "card": "Card",
      
      // Driver
      "goOnline": "Go Online",
      "goOffline": "Go Offline",
      "newRideRequest": "New Ride Request",
      "acceptRide": "Accept Ride",
      "declineRide": "Decline",
      "startRide": "Start Ride",
      "completeRide": "Complete Ride",
      "earnings": "Earnings",
      "todayEarnings": "Today's Earnings",
      "weekEarnings": "This Week",
      "monthEarnings": "This Month",
      "totalRides": "Total Rides",
      "rating": "Rating",
      "availability": "Availability",
      "online": "Online",
      "offline": "Offline",
      
      // Admin
      "dashboard": "Dashboard",
      "users": "Users",
      "drivers": "Drivers",
      "passengers": "Passengers",
      "rides": "Rides",
      "analytics": "Analytics",
      "activeRides": "Active Rides",
      "totalUsers": "Total Users",
      "revenue": "Revenue",
      "activeDrivers": "Active Drivers",
      "manageUsers": "Manage Users",
      "viewDetails": "View Details",
      "approve": "Approve",
      "suspend": "Suspend",
      "verified": "Verified",
      "pending": "Pending",
      "status": "Status"
    }
  },
  ar: {
    translation: {
      // Common
      "language": "اللغة",
      "logout": "تسجيل الخروج",
      "cancel": "إلغاء",
      "confirm": "تأكيد",
      "submit": "إرسال",
      "save": "حفظ",
      "edit": "تعديل",
      "delete": "حذف",
      "search": "بحث",
      "filter": "تصفية",
      "back": "رجوع",
      
      // Landing Page
      "appName": "سعيد تاكسي",
      "tagline": "رحلتك، بطريقتك",
      "description": "احجز رحلاتك فوراً في جميع أنحاء سوريا مع سعيد تاكسي. نقل آمن وموثوق وبأسعار معقولة في متناول يدك.",
      "bookRide": "احجز رحلة",
      "becomeDriver": "كن سائقاً",
      "adminPanel": "لوحة الإدارة",
      
      // Passenger
      "whereAreYouGoing": "إلى أين تذهب؟",
      "pickup": "موقع الانطلاق",
      "dropoff": "موقع الوصول",
      "findRide": "ابحث عن رحلة",
      "selectCar": "اختر السيارة",
      "confirmRide": "تأكيد الرحلة",
      "rideHistory": "سجل الرحلات",
      "myProfile": "ملفي الشخصي",
      "economy": "اقتصادي",
      "comfort": "مريح",
      "premium": "فاخر",
      "waitingForDriver": "جاري البحث عن سائق...",
      "driverArriving": "السائق في الطريق",
      "inProgress": "الرحلة جارية",
      "completed": "اكتملت الرحلة",
      "rateDriver": "قيّم السائق",
      "rateRide": "تقييم الرحلة",
      "addTip": "إضافة إكرامية",
      "paymentMethod": "طريقة الدفع",
      "cash": "نقداً",
      "card": "بطاقة",
      
      // Driver
      "goOnline": "متصل",
      "goOffline": "غير متصل",
      "newRideRequest": "طلب رحلة جديد",
      "acceptRide": "قبول الرحلة",
      "declineRide": "رفض",
      "startRide": "بدء الرحلة",
      "completeRide": "إنهاء الرحلة",
      "earnings": "الأرباح",
      "todayEarnings": "أرباح اليوم",
      "weekEarnings": "هذا الأسبوع",
      "monthEarnings": "هذا الشهر",
      "totalRides": "إجمالي الرحلات",
      "rating": "التقييم",
      "availability": "الحالة",
      "online": "متصل",
      "offline": "غير متصل",
      
      // Admin
      "dashboard": "لوحة التحكم",
      "users": "المستخدمين",
      "drivers": "السائقين",
      "passengers": "الركاب",
      "rides": "الرحلات",
      "analytics": "التحليلات",
      "activeRides": "الرحلات النشطة",
      "totalUsers": "إجمالي المستخدمين",
      "revenue": "الإيرادات",
      "activeDrivers": "السائقين النشطين",
      "manageUsers": "إدارة المستخدمين",
      "viewDetails": "عرض التفاصيل",
      "approve": "موافقة",
      "suspend": "تعليق",
      "verified": "موثق",
      "pending": "معلق",
      "status": "الحالة"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;